import { render, staticRenderFns } from "./Jjfa.vue?vue&type=template&id=32bf24eb&scoped=true"
import script from "./Jjfa.vue?vue&type=script&lang=js"
export * from "./Jjfa.vue?vue&type=script&lang=js"
import style0 from "./Jjfa.vue?vue&type=style&index=0&id=32bf24eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bf24eb",
  null
  
)

export default component.exports